import { render, staticRenderFns } from "./TaskCollectDetail.vue?vue&type=template&id=cbf3beac&"
import script from "./TaskCollectDetail.vue?vue&type=script&lang=js&"
export * from "./TaskCollectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports